import { datadogRum } from '@datadog/browser-rum';

const DD_APPLICATION_ID = import.meta.env.VITE_DD_APPLICATION_ID ?? '';
const DD_CLIENT_TOKEN = import.meta.env.VITE_DD_CLIENT_TOKEN ?? '';
const DD_SITE = import.meta.env.VITE_DD_SITE ?? 'datadoghq.com';
const DD_SERVICE = import.meta.env.VITE_DD_SERVICE ?? 'mentoria-aquias';
const DD_VERSION = import.meta.env.VITE_DD_VERSION ?? '1.0.0';
const DD_ENV = import.meta.env.VITE_DD_ENV ?? 'production';

export function initDatadogRum() {
  if (!DD_APPLICATION_ID || !DD_CLIENT_TOKEN) {
    console.warn('[Datadog] RUM not initialized: missing APPLICATION_ID or CLIENT_TOKEN');
    return;
  }

  datadogRum.init({
    applicationId: DD_APPLICATION_ID,
    clientToken: DD_CLIENT_TOKEN,
    site: DD_SITE,
    service: DD_SERVICE,
    version: DD_VERSION,
    env: DD_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      { match: /https:\/\/.*\.supabase\.co/, propagatorTypes: ['tracecontext'] },
    ],
  });

  datadogRum.startSessionReplayRecording();
}

export function setRumUser(userId: string, email: string, role: string) {
  datadogRum.setUser({
    id: userId,
    email: '',
    role,
  });
}

export function clearRumUser() {
  datadogRum.clearUser();
}

export function addRumError(error: Error, context?: Record<string, unknown>) {
  datadogRum.addError(error, context);
}
